import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { startWith, map } from 'rxjs/operators';

@Component({
  selector: 'app-auto-complete',
  templateUrl: './auto-complete.component.html',
})
export class AutoCompleteComponent implements OnInit {
  
  @Input() models:Array<any> = [];

  @Input() title:any = "";

  @Input() displayFn:any;

  @Input() filterFn:any;
  
  @Output() dataChanged = new EventEmitter<any>();
  
  private _model:any;
  @Input('model') get model(): any{
    return this._model;
  }
  set model(value: any) {
    this.formControl.setValue(value);
    this._model = value;
    this.dataChanged.emit(this._model);
  }


  formControl = new FormControl();
  filteredOptions : Observable<any>;
  
  constructor(){
  }

  ngOnInit(){
    this.filteredOptions = this.formControl.valueChanges
    .pipe(
      startWith<any>(''),
      map(value => typeof value === 'string' ? value : value? value.name:''),
      map(name => name ? this._filter(name) : this.models.slice())
    );

    this.formControl.valueChanges
    .subscribe(value => {
      if(typeof value == 'object'){
        // console.log("Datachanged");
        this.dataChanged.emit(value);
      }
    });

    if(this.model){
      this.formControl.setValue(this.model);
    }
  
  }

  private _filter(name: string): any[] {
    const filterValue = name.toLowerCase();
    return this.models.filter(option => this.filterFn(filterValue, option));
  }

  selectOption = (opcao) =>  {
    // console.log("teste");
    // console.log(opcao);
  }
  clear(){
    this.formControl.reset();
  }
}
